import styled from '@emotion/styled';
import {Text} from '@chakra-ui/react';

export const StyledSubtitleText = styled(Text)`
	border-bottom: 8px;
	font-style: 'Open Sans';
`;
